import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconSortAsc: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1C0 0.447715 0.447715 0 1 0H12C12.5523 0 13 0.447715 13 1C13 1.55228 12.5523 2 12 2H1C0.447715 2 0 1.55228 0 1ZM1.96429 4.5C1.96429 3.94772 2.412 3.5 2.96429 3.5H10.0357C10.588 3.5 11.0357 3.94772 11.0357 4.5C11.0357 5.05228 10.588 5.5 10.0357 5.5H2.96429C2.412 5.5 1.96429 5.05228 1.96429 4.5ZM4.32143 8C4.32143 7.44772 4.76914 7 5.32143 7H7.67857C8.23086 7 8.67857 7.44772 8.67857 8C8.67857 8.55228 8.23086 9 7.67857 9H5.32143C4.76914 9 4.32143 8.55228 4.32143 8Z"
      />
    </svg>
  </IconStyled>
);

IconSortAsc.defaultProps = iconDefaultProps;
IconSortAsc.displayName = 'IconSortAsc';

export default IconSortAsc;
